import { render } from "./KnParameterTreeDialog.vue?vue&type=template&id=943027c8&scoped=true&ts=true"
import script from "./KnParameterTreeDialog.vue?vue&type=script&lang=ts"
export * from "./KnParameterTreeDialog.vue?vue&type=script&lang=ts"

import "./KnParameterTreeDialog.vue?vue&type=style&index=0&id=943027c8&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-943027c8"]])

export default __exports__